import { Injectable } from '@angular/core';
import {AdvancedFormButton, ButtonStyleEnum, ButtonTypeEnum, FormFactory} from '@magieno/angular-advanced-forms';

@Injectable()
export class CalculationBaseFormFactory {

  protected optionsType: { new(...args: any[]): object; };

  constructor(protected readonly formFactory: FormFactory) {
  }

  // todo re add the icons
  create() {
    return this.formFactory.create(new this.optionsType(), [
      new AdvancedFormButton('SAVE', ButtonStyleEnum.Light, 'Sauvegarder', ButtonTypeEnum.Button, { shouldSubmitIfValidationFail: true }),
      new AdvancedFormButton('EXECUTE', ButtonStyleEnum.Primary, 'Calculer', ButtonTypeEnum.Submit, {}),
    ]);
  }
}